module.exports = __webpack_public_path__ + "img/user-4.9ccf74d1.svg";